//wamp门禁连接地址
export const WampConfig = {
    host: "www.vrmaker.com.cn",
    port: "10806"
}